var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.999 511.999",
    style: {
      enableBackground: "new 0 0 511.999 511.999"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EA971E"
    },
    cx: 256,
    cy: 255.997,
    r: 255.997
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C27526"
    },
    d: "M256.003,65.602L97.866,173.103h23.682v22.907h9.944v139.278h-9.944v22.907h-14.799v26.584 l126.173,126.173c7.605,0.68,15.3,1.047,23.081,1.047c136.502,0,248.037-106.839,255.58-241.453l-97.443-97.443l0,0h0.001 L256.003,65.602L256.003,65.602z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.235,
    y: 184.556,
    style: {
      fill: "#F9ED9D"
    },
    width: 51.538,
    height: 157.364
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 184.556,
    style: {
      fill: "#EA971E"
    },
    width: 25.774,
    height: 157.364
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C27526"
    },
    points: "97.866,173.103 256.003,65.602 414.139,173.103 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.284,
    y: 173.098,
    style: {
      fill: "#FFFFFF"
    },
    width: 71.43,
    height: 22.907
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 173.098,
    style: {
      fill: "#F4C479"
    },
    width: 35.715,
    height: 22.907
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.284,
    y: 335.289,
    style: {
      fill: "#FFFFFF"
    },
    width: 71.43,
    height: 22.907
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.977,
    y: 184.556,
    style: {
      fill: "#EA971E"
    },
    width: 51.538,
    height: 157.364
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 319.026,
    y: 173.098,
    style: {
      fill: "#F4C479"
    },
    width: 71.43,
    height: 22.907
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.026,
    y: 335.289,
    style: {
      fill: "#F4C479"
    },
    width: 71.43,
    height: 22.907
  })), /*#__PURE__*/React.createElement("rect", {
    x: 131.494,
    y: 184.556,
    style: {
      fill: "#F9ED9D"
    },
    width: 51.538,
    height: 157.364
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 121.553,
    y: 173.098,
    style: {
      fill: "#FFFFFF"
    },
    width: 71.43,
    height: 22.907
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.553,
    y: 335.289,
    style: {
      fill: "#FFFFFF"
    },
    width: 71.43,
    height: 22.907
  })), /*#__PURE__*/React.createElement("rect", {
    x: 106.745,
    y: 358.196,
    style: {
      fill: "#F9ED9D"
    },
    width: 298.51,
    height: 26.584
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#7E4F1F"
    },
    points: "256.003,65.602 256.003,173.103 414.14,173.103 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 335.289,
    style: {
      fill: "#F4C479"
    },
    width: 35.715,
    height: 22.907
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 358.196,
    style: {
      fill: "#EA971E"
    },
    width: 149.255,
    height: 26.584
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.f0e73eb2ca568646965e9e031665eb1e.svg";
export { ForwardRef as ReactComponent };